export default __webpack_public_path__ + "static/media/ForcedVibrationImg.60209743.jpg";